<template>
  <div class="item" v-if="episode_data">
    <div class="item__image" v-if="episode.image">
      <img :src="episode.image.url" :alt="episode.image.alt">
    </div>
    <div class="item__text">
      <router-link :to="{name: 'podcast', params: {id: episode.id}}">{{ episode.title }}</router-link>
      <p v-if="shortDescription">{{ shortDescription }}</p>
    </div>
    <div class="item__meta">
      <div class="date_time">
        <span>{{ episode.date }}</span>
        <span v-if="length">{{ length }} min.</span>
      </div>
      <button class="play" @click="handlePlayButton">
        <i :class="{'icon-play': !this.isCurrentEpisodePlaying, 'icon-pause': this.isCurrentEpisodePlaying}"></i>
        <span class="sr-only">{{ this.isCurrentEpisodePlaying ? 'Pause' : 'Play' }} {{ episode.title }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    episode: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    episode_data: null
  }),
  computed: {
    shortDescription() {
      return this.episode.about_raw ? this.episode.about_raw.substring(0, 256) + '...' : null;
    },
    length() {
      if (!this.episode_data.duration) {
        return null;
      }
      const duration = this.episode_data.duration.split(':');

      return (+duration[0]) * 60 + (+duration[1]);
    },
    isCurrentEpisodePlaying() {
      const currentEpisode = this.$store.getters['podcast/episode']

      if (!currentEpisode || currentEpisode.id !== this.episode.id) {
        return false;
      }

      return this.$store.getters['podcast/isPlaying'] || false
    }
  },
  mounted() {
    this.loadVideoConfig()
  },
  methods: {
    loadVideoConfig() {
      if (!this.episode.audio_file) {
        return;
      }

      this.$wmtVideoAxios.get(`/api/v1/ext/video/${this.episode.audio_file}/config.json`).then(r => {
        this.episode_data = r.data.data
      })
    },
    handlePlayButton() {
      if (parseInt(this.$route.params.id) === this.episode.id) {
        this.$emit('play')
      } else {
        this.$router.push({name: 'podcast', params: {id: this.episode.id}})
      }
    }
  }
}
</script>
